import BrandLogo from './brand_logo';

export default BrandLogo;
